import Decimal from "decimal.js";

export type DecimalLike = Decimal.Value;

export class DMath {
  static toDecimal(value: DecimalLike): Decimal {
    try {
      if (value === null || value === undefined) return new Decimal(0);
      if (Decimal.isDecimal(value)) return value;
      return new Decimal(value);
    } catch (ex) {
      // console.log(ex);
      return new Decimal(0);
    }
  }

  static add(a: DecimalLike, b: DecimalLike): Decimal {
    return this.toDecimal(a).add(this.toDecimal(b));
  }

  static sub(a: DecimalLike, b: DecimalLike): Decimal {
    return this.toDecimal(a).sub(this.toDecimal(b));
  }

  static mul(a: DecimalLike, b: DecimalLike): Decimal {
    return this.toDecimal(a).mul(this.toDecimal(b));
  }

  static div(a: DecimalLike, b: DecimalLike): Decimal {
    return this.toDecimal(a).div(this.toDecimal(b));
  }

  static percent(value: DecimalLike, percentage: DecimalLike): Decimal {
    return this.mul(value, this.div(percentage, 100));
  }

  static round(value: DecimalLike): Decimal {
    return this.toDecimal(value).round();
  }

  static abs(value: DecimalLike): Decimal {
    return this.toDecimal(value).abs();
  }

  static clamp(
    value: Decimal.Value,
    min: Decimal.Value,
    max: Decimal.Value,
  ): Decimal {
    return Decimal.max(min, Decimal.min(max, value));
  }

  static gt(a: DecimalLike, b: DecimalLike): boolean {
    return this.toDecimal(a).gt(this.toDecimal(b));
  }

  static gte(a: DecimalLike, b: DecimalLike): boolean {
    return this.toDecimal(a).gte(this.toDecimal(b));
  }

  static lt(a: DecimalLike, b: DecimalLike): boolean {
    return this.toDecimal(a).lt(this.toDecimal(b));
  }

  static lte(a: DecimalLike, b: DecimalLike): boolean {
    return this.toDecimal(a).lte(this.toDecimal(b));
  }

  static eq(a: DecimalLike, b: DecimalLike): boolean {
    return this.toDecimal(a).eq(this.toDecimal(b));
  }

  static neq(a: DecimalLike, b: DecimalLike): boolean {
    return !this.eq(a, b);
  }

  static ceil(value: DecimalLike): Decimal {
    return this.toDecimal(value).ceil();
  }

  static floor(value: DecimalLike): Decimal {
    return this.toDecimal(value).floor();
  }

  static toFixed(value: DecimalLike, digits = 2): string {
    return this.toDecimal(value).toFixed(digits);
  }

  static toNumber(value: DecimalLike): number {
    return this.toDecimal(value).toNumber();
  }

  static toString(value: DecimalLike): string {
    return this.toDecimal(value).toString();
  }
}
